import type { ReactElement } from "react";
import { NavLink } from "react-router-dom";
import { cn } from "@/lib/cn";

interface NavItem {
  to: string;
  label: string;
}

const NAV_ITEMS: readonly NavItem[] = [
  { to: "/dashboard", label: "Dashboard" },
  { to: "/market", label: "Market" },
  { to: "/strategies", label: "Strategies" },
  { to: "/broker", label: "Broker" },
  { to: "/trade-log", label: "Trade Log" },
  { to: "/simulator", label: "Simulator" },
  { to: "/backup", label: "Backup" },
];

export function Nav(): ReactElement {
  return (
    <nav className="flex gap-1">
      {NAV_ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) =>
            cn(
              "rounded-ctl px-3 py-1.5 text-sm font-medium transition-colors",
              isActive
                ? "bg-accent-bg text-accent"
                : "text-ink-secondary hover:bg-surface-2 hover:text-ink",
            )
          }
        >
          {item.label}
        </NavLink>
      ))}
      {/* Reports is a standalone page (no app shell) — open in its own
          tab, same pattern as the strategy cockpit. No `rel`: it is
          same-origin, and `noreferrer` implies `noopener`, which would
          isolate the tab from the shared TradingView window (2026-08-12). */}
      <a
        href="/reports"
        target="_blank"
        className="rounded-ctl px-3 py-1.5 text-sm font-medium text-ink-secondary transition-colors hover:bg-surface-2 hover:text-ink"
      >
        Reports <i className="ti ti-external-link text-xs" />
      </a>
      {/* Charts is the chart page (public/chart/, built from the hl-charts project). It wants the whole
          window, so it opens in its own tab like Reports; the same address, so the dashboard login goes
          with it, and its data comes from the login-protected /api/chart routes. */}
      <a
        href="/chart/"
        target="_blank"
        className="rounded-ctl px-3 py-1.5 text-sm font-medium text-ink-secondary transition-colors hover:bg-surface-2 hover:text-ink"
      >
        Charts <i className="ti ti-external-link text-xs" />
      </a>
    </nav>
  );
}
